import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IDestination } from "../destinationModel";

export const getAllDestination = createAsyncThunk(
  "Destination/FindAllDestination",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Destination/FindAllDestination`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Destination:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createDestination = createAsyncThunk(
  "Destination/InsertDestination",
  async (DestinationData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Destination/InsertDestination`,
        DestinationData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Destination:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateDestination = createAsyncThunk(
  "Destination/UpdateDestination",
  async (DestinationData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Destination/UpdateDestination`,
        DestinationData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Destination :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteDestination = createAsyncThunk(
  "Destination/DeleteDestination",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Destination/DeleteDestination`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Destination :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDestinationByID = createAsyncThunk(
  "Destination/FindByIDDestination",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Destination/FindByIDDestination`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        DestinationURL: result.DestinationURL,
        DestinationImg: result.DestinationImg,
        DestinationLogo: result.DestinationLogo,
        IsActive: result.IsActive ? 1 : 2,
      } as IDestination;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Destination :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveDestination = createAsyncThunk(
  "Destination/FindAllActiveDestination",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Destination/FindAllActiveDestination`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Destination:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveDestination = createAsyncThunk(
  "Destination/ActiveInActiveDestination",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Destination/ActiveInActiveDestination`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Destination :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const DestinationImageUpload = createAsyncThunk(
  "Destination/DestinationImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Destination/DestinationImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Destination Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
